<template>
  <div v-if="signedIn">
    <div v-if="underMaintenance">
      <div class="maintenance"></div>
    </div>
    <div v-else>
      <v-app id="inspire" :class="{ watermark: isStaging }">
        <div style="width: 100%" else>
          <v-navigation-drawer
            color="dark"
            v-model="drawer"
            dark
            app
            :class="{ watermarksm: isStaging }"
          >
            <v-list dense>
              <v-list-item
                v-for="(menu, i) in $routes.filter(x =>
                available.radiusServiceId
                  ? true
                  : (x.path === '/wholesaler-list' ||
                      x.path === '/import-rundeck' || x.path === '/ip-address') &&
                    $store.getters['auth/isAppAdmin']
                  ? true
                  : x.path === '/' || x.path === '*'
              )"
                :key="`${i}+${menu.path}`"
                :to="
                `${
                  menu.path.includes('service-details')
                    ? '/service-details/' + $route.params.acct
                    : menu.path
                }`
              "
                v-show="menu.hidden !== true"
              >
                <v-list-item-action>
                  <v-icon>{{ menu.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ menu.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-navigation-drawer>

          <v-app-bar
            app
            color="dark"
            dark
            height="auto"
            :class="
            $vuetify.breakpoint.mdAndDown &&
            $route.path !== '/'
              ? 'pb-2'
              : ''
          "
          >
            <v-row class="justify-space-between">
              <v-col class="mt-2 py-0" cols="12" md="12" lg="9">
                <v-app-bar-nav-icon
                  @click.stop="drawer = !drawer"
                ></v-app-bar-nav-icon>
                <span class="title">{{ currentServiceTitle }}</span>
              </v-col>
              <v-col
                class="py-0"
                v-if="!checkRoute"
                md="12"
                lg="3"
                :class="
                $vuetify.breakpoint.smAndDown ? 'px-0 px-0 mx-4' : 'pr-3 mt-1'
              "
              >
                <search-bar
                  ref="search"
                  v-if="$route.path !== '/import-rundeck' && $route.path !== '/ip-address'"
                ></search-bar>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <v-col
              class="text-center caption font-weight-black"
              v-if="impersonating && impersonating.impersonateEmail"
            >
              Viewing as:
              {{ impersonating.impersonateEmail }}
              <v-divider
                vertical
                color="black"
                class="mx-4 hidden-sm-and-down"
              ></v-divider>
              <v-btn text small class="primary mt-n2" @click="remove"
              >Logout</v-btn
              >
            </v-col>
            <v-menu v-if="isAdmin" transition="slide-y-transition" offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item-group>
                  <v-list-item :to="'/account'">
                    <v-list-item-content>
                      <v-list-item-title class="d-flex align-center">
                        <v-icon class="mr-1" color="primary"
                        >mdi-account-settings</v-icon
                        >My Account
                      </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  @click="viewAsTable"
                  v-if="!(impersonating && impersonating.impersonateEmail)"
                >
                  <v-list-item-title class="d-flex align-center">
                    <v-icon class="mr-1" color="primary">mdi-eye</v-icon>View As
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="mgr.signOut">
                  <v-list-item-title class="d-flex align-center">
                    <v-icon class="mr-1" color="primary">mdi-logout</v-icon
                    >Logout
                  </v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-app-bar>

          <v-main
            color="primary"
            :class="
            $vuetify.breakpoint.mdAndDown &&
            $route.path !== '/'
              ? 'smallWidth'
              : 'largeWidth'
          "
          >
            <router-view></router-view>
          </v-main>

          <process-loader :isActive="isProcessingActive"></process-loader>
          <http-response
            :text="httpText"
            :color="httpColor"
            :isActive="httpIsActive"
          ></http-response>
          <view-table ref="viewTable" @change="$router.go(0)"></view-table>
        </div>
      </v-app>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/search-bar";
import Mgr from "@/services/SecurityService";
import ViewTable from "@/components/ViewTable";
import * as LDClient from "launchdarkly-js-client-sdk";

export default {
  name: "App",
  data: () => ({
    drawer: null,
    mgr: new Mgr(),
    signedIn: true,
    isVispAdmin: false
  }),
  components: {
    SearchBar,
    ViewTable
  },
  mounted() {
    let vm = this;
    this.mgr.getSignedIn().then(
      signIn => {
        this.signedIn = signIn;
        vm.getImpersonating();
        this.$store.dispatch("auth/isAppAdmin");

        vm.mgr.getProfile().then(data => {
          let impersonate = vm.$store.getters["impersonate/impersonating"];
          let user = {
            key: ""
          };

          // Include impersonation in feature flag logic
          if (impersonate) {
            user.key = impersonate.data
              ? impersonate.data.impersonateEmail
              : impersonate.impersonateEmail;
          } else {
            user.key = data.name;
          }

          const client = LDClient.initialize(process.env.LAUNCHDARKLY, user);

          client.on("ready", function() {
            vm.$store.dispatch("featureFlag/setAllFlags", client.allFlags());
          });

          client.on("change", function() {
            vm.$store.dispatch("featureFlag/setAllFlags", client.allFlags());
          });
        });
      },
      err => {
        console.log(err);
      }
    );

    // this.mgr.getRole().then(
    //   (data) => {
    //     this.isVispAdmin = data.includes("VispAdmin");
    //   }
    // );
  },
  watch: {
    $route(to) {
      let vm = this;
      if (vm.available.radiusServiceId)
        vm.$route.params.acct = vm.available.radiusServiceId;
    }
  },
  methods: {
    remove() {
      this.removeImpersonating().then(() => {
        window.location.href = "/";
      });
    }
  },
  created() {
    this.setProcessInactive();
    this.resetHttpResponse();
  },
  computed: {
    currentServiceTitle() {
      return this.available.serviceId
        ? `${this.available.serviceId} ${this.available.serviceDescription}`
        : "";
    },
    checkRoute() {
      let vm = this;
      return (
        vm.$route.path === "/" ||
        vm.$route.path === "*" ||
        vm.$route.path === "/auth" ||
        vm.$route.path === "/unauthorized" ||
        vm.$route.path === "/wholesaler-list"
      );
    },
    underMaintenance() {
      let vm =this;
      let flags = vm.$store.getters["featureFlag/allFlags"];
      return flags.SOG4874;
    },
    isStaging() {
      return (
        process.env.NODE_ENV == "Staging" ||
        process.env.NODE_ENV == "development"
      );
    }
  }
};
</script>

<style lang="scss">
#inspire {
  background-color: #f5f5f5;
}
.v-main__wrap {
  padding-bottom: 50px;
}
.v-toolbar {
  position: relative;
}

.maintenance {
  background-image: url('/undermantainance.jpg');
  height: 100vh;
  width: 100vw;

  background-size: 100%;
  background-repeat: no-repeat;
}


.logout-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 10px;
  -webkit-user-select: none;
  color: #fff !important;
  -moz-user-select: -moz-none;
  background-color: #e35d6b;
}
label > .v-icon {
  top: -1px;
  left: 0;
}

.v-error {
  color: red;
}

.container .v-card {
  margin-bottom: 12px;
}

.largeWidth {
  margin-top: 65px;
}

.smallWidth {
  margin-top: 120px;
}
.watermark {
  background: url("https://vonex.com.au/vonex/projects/watermark-blck.png")
    repeat !important;
}
.watermarksm {
  background: url("https://vonex.com.au/vonex/projects/watermark-small.png")
    repeat !important;
}
</style>
